import BuildingType, { isHomeOrFarm, isWorkShop } from '@/roc/building/BuildingType';
import Eras from '@/roc/era';
import { BuildingFlags } from "@/roc/building/BuildingTemplate";
const calculateMaxLevel = function (buildingTemplate, currentEra) {
    let perEra = 0;
    switch (buildingTemplate.type) {
        case BuildingType.HOME:
        case BuildingType.FARM:
            perEra = 3;
            break;
        case BuildingType.BARRACKS:
        case BuildingType.WORKSHOP_1:
        case BuildingType.WORKSHOP_2:
        case BuildingType.WORKSHOP_3:
        case BuildingType.CULTURE:
        case BuildingType.CITY_HALL:
            perEra = 1;
            break;
        default:
            return buildingTemplate.maxLevel;
    }
    let result = buildingTemplate.minLevel - 1;
    if (isHomeOrFarm(buildingTemplate.type) && (buildingTemplate.flags & BuildingFlags.LUXURIOUS) !== 0) {
        result = 0;
    }
    const eras = Object.keys(Eras);
    const currentEraIndex = eras.indexOf(currentEra);
    const buildingEraIndex = eras.indexOf(buildingTemplate.era);
    for (let i = buildingEraIndex; i <= currentEraIndex; i++) {
        result += perEra;
    }
    if (result > buildingTemplate.maxLevel) {
        result = buildingTemplate.maxLevel;
    }
    return result;
};
const calculateInitialLevel = function (buildingTemplate, currentEra) {
    switch (buildingTemplate.type) {
        case BuildingType.HOME:
        case BuildingType.FARM:
        case BuildingType.BARRACKS:
        case BuildingType.WORKSHOP_1:
        case BuildingType.WORKSHOP_2:
        case BuildingType.WORKSHOP_3:
        case BuildingType.CULTURE:
        case BuildingType.CITY_HALL:
            return calculateMaxLevel(buildingTemplate, currentEra);
        default:
            return buildingTemplate.minLevel;
    }
};
const calculateBuildingEraFromLevel = function (level, buildingTemplate, selectedEra) {
    let levelsPerEra = 0;
    switch (buildingTemplate.type) {
        case BuildingType.HOME:
        case BuildingType.FARM:
            levelsPerEra = 3;
            break;
        case BuildingType.BARRACKS:
        case BuildingType.WORKSHOP_1:
        case BuildingType.WORKSHOP_2:
        case BuildingType.WORKSHOP_3:
        case BuildingType.CULTURE:
        case BuildingType.CITY_HALL:
            levelsPerEra = 1;
            break;
        case BuildingType.EVENT:
            return selectedEra;
        default:
            return buildingTemplate.era;
    }
    const allEras = Object.keys(Eras);
    const initialBuildingEra = allEras.indexOf(buildingTemplate.era);
    let result = null;
    for (let i = buildingTemplate.minLevel, j = initialBuildingEra; i <= buildingTemplate.maxLevel; i += levelsPerEra, j++) {
        const minLevel = i;
        const maxLevel = i + levelsPerEra - 1;
        if (level >= minLevel && level <= maxLevel) {
            result = allEras[j];
            break;
        }
    }
    const happiness = buildingTemplate.effects.getHappiness();
    if (result &&
        happiness &&
        !happiness.hasAmountForEra(result) &&
        isWorkShop(buildingTemplate.type)) {
        result = 'romanEmpire';
    }
    return result;
};
const BuildingLevel = {
    calculateMaxLevel,
    calculateInitialLevel,
    calculateBuildingEraFromLevel
};
export default BuildingLevel;
